// Deleted Project from Supabase - Use constants for displaying guest book, new project can create a new supabase project or other database table, add the appropriate columns and update the api calls.
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://vypfsnxifajfxzipdvtl.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ5cGZzbnhpZmFqZnh6aXBkdnRsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQwNTc1NjQsImV4cCI6MjA0OTYzMzU2NH0.m9jHdDTcK9-z_HkhrmDsjDgU5v1G3JHorwxF98FskME'
export const supabaseClient = createClient(supabaseUrl, supabaseKey);
